import { Button, ClippedContent, Icon, LinkedAccount, USER_PERMISSIONS } from 'dyl-components'
import RestrictedView from 'shared/RestrictedView'
import { Link } from 'react-router-dom'
import accountOptionsActions from 'actions/account_options';
import { useDispatch } from 'react-redux';
import { Grid, Pagination, Segment } from 'semantic-ui-react';
import { PhoneUtil } from 'utils';

const LIMIT = 5;

const AccountSearchResults = ({ loading, results: account_options, onChange, value, setState, setLoading, state }) => {
    const dispatch = useDispatch();
    const paginationProps = {
        boundaryRange: 0,
        activePage: state.page,
        ellipsisItem: null,
        siblingRange: 2,
        totalPages: Math.ceil(state.count / LIMIT),
        onPageChange: async (_, { activePage }) => {
            setLoading(true);
            setState({ ...state, open: true, page: activePage });
            const { data, count } = await dispatch(accountOptionsActions.read({ page: activePage, search: state.search, limit: LIMIT, customer: true }));
            setState({ ...state, options: data, count, open: true, page: activePage, search: state.search, isFocused: true });
            setLoading(false);
        }
    }
    return (
        <Segment loading={loading || state.loading}>
            <Grid className='AccountSearchResults__Grid'>
                {account_options.map(data => {
                    const selected = value?.findIndex((val) => val?.id === data.id) !== -1
                    return (
                        <Grid.Row columns={'equal'} verticalAlign='middle'>
                            <Grid.Column>
                                <LinkedAccount
                                    account={data.name}
                                    maxWidth={'9em'}
                                    subtitle={data.id && `ID: ${data.id}`}
                                    popup
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <ClippedContent>{data.email}</ClippedContent>
                            </Grid.Column>
                            <Grid.Column>
                                <ClippedContent>{PhoneUtil.formatPhoneNumber(data.phone)}</ClippedContent>
                            </Grid.Column>
                            <Grid.Column>
                                {data.master_account?.name && (
                                    <ClippedContent>
                                        <Icon className={`${data.account_type === 'business' ? 'fa-solid fa-building' : 'fa-solid fa-house-chimney-blank'}`} />{data.master_account?.name}
                                    </ClippedContent>
                                )}
                            </Grid.Column>
                            <Grid.Column width={1}>
                                <RestrictedView type="link" userPermission={USER_PERMISSIONS.ACCOUNT_VIEW} userRestrict assignmentIds={[data?.assignees?.owner_id || 0, data?.assignees?.coowner_id || 0]}>
                                    <Link onClick={e => { e.stopPropagation(); }} target={"_blank"} to={`/account/${data.id}`}>{<Icon className='fas fa-external-link' />}</Link>
                                </RestrictedView>
                            </Grid.Column>
                            <Grid.Column>
                                <RestrictedView type="disabled" userPermission={USER_PERMISSIONS.ACCOUNT_EDIT} userRestrict assignmentIds={[data?.assignees?.owner_id || 0, data?.assignees?.coowner_id || 0]}>
                                    <Button type='button' fluid color='primary' onClick={e => { e?.stopPropagation(); e?.preventDefault(); onChange(e, [...value, data]); }} disabled={selected}>
                                        {selected ? 'Added' : 'Add'}
                                    </Button>
                                </RestrictedView>
                            </Grid.Column>
                        </Grid.Row>
                    );
                })}
            </Grid>
            <Segment className="SeachableOptions__floatingPagination" textAlign="right">
                <Pagination {...paginationProps} />
            </Segment>
        </Segment>
    )
}

export default AccountSearchResults
